export default function PortfolioModule(element) {
    let qsa = element.querySelectorAll.bind(element);

    let tl = gsap.timeline({
        scrollTrigger: { trigger:element, end: 'top top' }
    });

    qsa('.portfolio__item').forEach((subElem, index) => {
        tl.from(subElem, {y: 300, opacity: 0.1}, '<0.2');
    });
}
